module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("Kontrahenci")]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('form-group', {
    attrs: {
      "label": "Treść o kontrahentach",
      "error": _vm.errors['producerList.content']
    }
  }, [_c('textarea-input', {
    attrs: {
      "rows": "10"
    },
    model: {
      value: (_vm.producerList.content),
      callback: function($$v) {
        _vm.producerList.content = $$v
      },
      expression: "producerList.content"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('submit-button', {
    staticClass: "pull-right",
    attrs: {
      "submitting": _vm.submitting
    }
  }), _vm._v(" "), _c('br'), _c('br')], 1), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": _vm.getRouteToAdd
    }
  }, [_vm._v("Dodaj kontrahenta")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-bordered table-hover"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.producers), function(producer, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(producer.name))]), _vm._v(" "), _c('td', [_c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index !== 0),
        expression: "index !== 0"
      }],
      staticClass: "btn btn-default btn-sm",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.moveUp(producer)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-chevron-up"
    })]), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index !== _vm.producers.length - 1),
        expression: "index !== producers.length - 1"
      }],
      staticClass: "btn btn-default btn-sm",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.moveDown(producer)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-chevron-down"
    })])]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "btn btn-default btn-sm",
      attrs: {
        "to": _vm.getRouteToEdit(producer)
      }
    }, [_vm._v("Edytuj")]), _vm._v(" "), _c('question-button', {
      staticClass: "btn btn-danger btn-sm",
      attrs: {
        "question": "Czy na pewno usunąć tego producenta?"
      },
      on: {
        "click": function($event) {
          _vm.remove(producer)
        }
      }
    }, [_vm._v("\n          Usuń\n        ")])], 1)])
  }))])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Nazwa")]), _vm._v(" "), _c('th', [_vm._v("Pozycja")]), _vm._v(" "), _c('th')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67001c7c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Producers.vue
// module id = 454
// module chunks = 1